export default __webpack_public_path__ + "static/media/footer-thop.364525ed.png";